window.OneLuxuryMenuAnchorManifest = Object.freeze([
  { id: 'home', position: [6.25, 3.7, 0.35] },
  { id: 'shop-minis', position: [6.35, 2.96, 0.2] },
  { id: 'custom-design', position: [6.2, 2.22, 0.1] },
  { id: 'marine', position: [6.3, 1.48, -0.05] },
  { id: 'sports', position: [6.22, 0.74, 0.15] },
  { id: 'symbols', position: [6.34, 0, -0.1] },
  { id: 'fashion', position: [6.2, -0.74, 0.05] },
  { id: 'jewelry-estimator', position: [6.32, -1.48, 0.2] },
  { id: 'concierge', position: [6.22, -2.22, -0.05] },
  { id: 'appointment', position: [6.34, -2.96, 0.1] },
  { id: 'back-to-orbit', position: [6.24, -3.7, 0.3] }
]);
